import * as React from "react";
import { forwardRef } from "react";
const SvgDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, transform: "translate(2 2)" }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, rx: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M0 4.615h20m-12.857 0V20m0-7.692H20" })));
const ForwardRef = forwardRef(SvgDefault);
export { ForwardRef as ReactComponent };
